'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill(text, isNew) {
  this.gw = null;
  this.gv = false;
  this.gw = text;
  this.gv = isNew;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill as $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$HeroPill() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$HeroPill as $h_Lio_intela_sites_digitalinternship_data_Segments$HeroPill };
$h_Lio_intela_sites_digitalinternship_data_Segments$HeroPill.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (-554394509));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gw));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.gv ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().Q(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill) && ((this.gv === x$0.gv) && (this.gw === x$0.gw))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "HeroPill";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.gw;
  }
  if ((n === 1)) {
    return this.gv;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HeroPill(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bA)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HeroPill as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HeroPill };
var $d_Lio_intela_sites_digitalinternship_data_Segments$HeroPill = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$HeroPill, "io.intela.sites.digitalinternship.data.Segments$HeroPill", ({
  bA: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$HeroPill as $d_Lio_intela_sites_digitalinternship_data_Segments$HeroPill };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Hero-Pill.js.map
